import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.css';
import './fonts/Bebas/Bebas-Regular.ttf';
import './fonts/lemon_milk/LEMONMILK-Regular.otf';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

